import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  providers: [],
})
export class BreadcrumbComponent implements OnInit {
  #router: Router = inject(Router);
  #activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);
  title = '';

  breadcrumb: { title: string; url: string }[] = [];

  ngOnInit(): void {
    this.getBreadcrumb();
  }

  getBreadcrumb() {
    this.breadcrumb = this.buildBreadcrumbs(this.#activatedRoute.root);

    this.#router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumb = this.buildBreadcrumbs(this.#activatedRoute.root);
      });
  }

  buildBreadcrumbs(activatedRoute: ActivatedRoute, url = '') {
    const children: ActivatedRoute[] = activatedRoute.children;
    let breadcrumbs: { title: string; url: string }[] = [];

    if (children.length === 0) {
      return [];
    }

    for (const child of children) {
      const routeData = child?.snapshot?.data;
      const routeURL: string = child?.snapshot?.url
        .map(segment => segment.path)
        .join('/');

      if (routeURL !== '') {
        url += `/${routeURL}`;
      } else {
        url = routeData?.breadcrumb?.url;
      }

      if (routeData?.breadcrumb) {
        breadcrumbs.push({ title: routeData.breadcrumb.title, url: url });
      }

      breadcrumbs = breadcrumbs.concat(this.buildBreadcrumbs(child, url));
    }

    return breadcrumbs;
  }
}
